import * as ng from 'angular';
import * as moment from 'moment';

ng.module('e360')
   .directive('dateGreater', dateGreaterDirective);

dateGreaterDirective.$inject = ['$parse'];
export function dateGreaterDirective($parse:ng.IParseService):ng.IDirective {
   return {
      restrict: 'A',
      require: 'ngModel',
      link: dateGreaterDirectiveLinkFn
   };

   function dateGreaterDirectiveLinkFn(
      scope:ng.IScope,
      element:JQuery,
      attrs:ng.IAttributes,
      ngModel:ng.INgModelController
   ) {
      ngModel.$validators.dateGreater = dateGreaterValidator;

      const format = 'MM/DD/YYYY hh:mm A';
      let otherDateExpr = $parse(attrs['dateGreater']);

      // run validators when other date changes so we can update validity
      scope.$watch(attrs['dateGreater'], () => ngModel.$validate());

      function dateGreaterValidator(modelValue, viewValue) {
         if (ngModel.$isEmpty(modelValue)) {
            // consider empty models to be valid
            return true;
         }

         let otherDateValue = otherDateExpr(scope);

         // consider empty value for other date to be valid
         if (!otherDateValue) {
            return true;
         }

         let otherDate = moment(otherDateValue, format);
         let myDate = moment(viewValue, format);

         return otherDate.isSameOrBefore(myDate);
      }
   }
}
